import { Icon, Spinner, Text } from '@ui/themed';
import { t } from 'i18next';
import type { CartPrefillStatus } from './use-cart-prefill';

// The prefill runs eagerly while the buyer reads the step, so its outcome is settled (and honest)
// before they head off to the storefront.
export function CartPrefillStatusLine({ status }: { status: CartPrefillStatus }) {
  return (
    <span className="flex items-center gap-1.5">
      {status === 'adding' && <Spinner />}
      {status === 'added' && <Icon name="checkCircle" size="sm" />}
      {status === 'manual' && <Icon name="infoCircle" size="sm" />}
      <Text variant="secondary">{statusCopy(status)}</Text>
    </span>
  );
}

function statusCopy(status: CartPrefillStatus): string {
  switch (status) {
    case 'adding':
      return t('features:onboarding.components.order_item.prefill_adding');
    case 'added':
      return t('features:onboarding.components.order_item.prefill_added');
    case 'manual':
      return t('features:onboarding.components.order_item.prefill_manual');
  }
}
